import get from 'lodash/get';
import { getUserData } from '../../resources';
import giaSerializer from '../serializers/gia';
import mainDataSerializer from '../serializers/mainDataSerializer';
import passportSerializer from '../serializers/passportSerializer';
import {
  CHANGE_STEP,
  REQUEST_USER_DATA,
  RECEIVE_USER_DATA,
  FAILURE_USER_DATA,
  SET_GIA_ITEMS,
  SET_MAIN_DATA,
  SET_PASSPORT_DATA,
  SET_PASSPORT_DATA_CHILD,
  CHANGE_MAIN_DATA,
  REQUEST_ERROR_HIDE,
  CHANGE_MAIN_DATA_CHILD
} from '../constants';
import { EMPTY_SNILS_STEP } from '../../constants/steps';
import { mainDataValuesSelector } from '../mainData/selectors';
import { mainDataValuesSelector as mainDataChildValuesSelector } from '../mainDataChild/selectors';
import passportChildSerializer from '../serializers/passportChildSerializer';
import { resetMainDataSubmit } from '../mainData/actions';
import { resetActRecordData } from '../actRecord/actions';
import {
  sendCMAAppealBusinessError,
  sendCMAAppealTechError
} from '../../helpers/CMAStats';

export const checkUserSnilsMiddleware = () => next => action => {
  if (action.type !== RECEIVE_USER_DATA) {
    return next(action);
  }

  const userSnils = get(action.payload.data, 'snils.snils_number', null);

  if (userSnils) {
    return next(action);
  }

  sendCMAAppealBusinessError({ stage: 'start' });

  return next({ type: CHANGE_STEP, payload: EMPTY_SNILS_STEP });
};

export const getUserDataMiddleware = ({ dispatch }) => next => action => {
  if (action.type !== REQUEST_USER_DATA) {
    return next(action);
  }

  getUserData()
    .then(response => {
      dispatch({
        type: REQUEST_ERROR_HIDE
      });
      dispatch({
        type: SET_MAIN_DATA,
        payload: mainDataSerializer(response, action.payload)
      });
      dispatch({
        type: SET_PASSPORT_DATA,
        payload: passportSerializer(response)
      });
      dispatch({
        type: RECEIVE_USER_DATA,
        payload: response
      });
      dispatch({
        type: SET_GIA_ITEMS,
        payload: giaSerializer(response)
      });
      dispatch(resetActRecordData());
    })
    .catch(error => {
      sendCMAAppealTechError({ stage: 'start' });
      dispatch({ type: FAILURE_USER_DATA, error });
    });

  return next(action);
};

export const changeUserDataMiddleware = ({
  dispatch,
  getState
}) => next => action => {
  if (
    action.type !== CHANGE_MAIN_DATA &&
    action.type !== CHANGE_MAIN_DATA_CHILD
  ) {
    return next(action);
  }

  const isChild = action.type === CHANGE_MAIN_DATA_CHILD;
  const mainData = isChild
    ? mainDataChildValuesSelector(getState())
    : mainDataValuesSelector(getState());
  const { citizenship, birthdate } = action.payload.data;

  if (citizenship && citizenship !== mainData.citizenship) {
    dispatch({
      type: isChild ? SET_PASSPORT_DATA_CHILD : SET_PASSPORT_DATA,
      payload: {
        ...passportChildSerializer(action.payload.data),
        citizenship
      }
    });
    dispatch(resetActRecordData());
  }

  if (birthdate !== mainData.birthdate) {
    dispatch(resetMainDataSubmit());
  }

  return next(action);
};
